export const MGM_CHALLENGE_STUB = Object.freeze({
  name: 'Indique a Jusfy',
  points: 300,
} as const);
